import { useElements } from '@stripe/react-stripe-js';

import { Intent, SetupIntentData } from '../../../api/payment';
import {
  usePaymentStore,
  paymentStoreSelector,
  Services,
} from '../../../stores/paymentStore';
import {
  ConfirmIntentParams,
  IntentResult,
  OperationResult,
} from '../../../stores/paymentStore/types';

interface PaymentFormHandlers {
  validateForm: () => Promise<boolean>;
  updateBillingInfo: () => Promise<void>;
  setIntent: (data: Intent) => void;
  setupIntent: (data: SetupIntentData) => Promise<IntentResult | void>;
  confirmIntent: (
    params: ConfirmIntentParams
  ) => Promise<OperationResult | void>;
}

const usePaymentFormHandlers = ({
  service,
}: {
  service: Services;
}): PaymentFormHandlers => {
  const elements = useElements();

  const paymentActions = usePaymentStore(paymentStoreSelector.actions);

  const handlers: PaymentFormHandlers = {
    validateForm: async () => {
      if (!elements) {
        return false;
      }

      const result = await elements.submit();

      return !result.error;
    },
    updateBillingInfo: async () => {
      if (elements) {
        const address = await elements.getElement('address')?.getValue();
        if (address?.isNewAddress) {
          await paymentActions.updateBillingInfo(address.value);
        }
      }
    },
    setIntent: (data) => paymentActions.setIntent({ service }, data),
    setupIntent: (data) => paymentActions.setupIntent({ service }, data),
    confirmIntent: async (params) => {
      if (!elements) {
        return;
      }

      return paymentActions.confirmIntent(elements, params);
    },
  };

  return handlers;
};

export default usePaymentFormHandlers;
